import * as types from './types';

export const findProduct = id => ({
  type: types.FIND_PRODUCT,
  payload: { id },
});
